import { render, staticRenderFns } from "./NewTable.vue?vue&type=template&id=318f9766&scoped=true&"
import script from "./NewTable.vue?vue&type=script&lang=js&"
export * from "./NewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318f9766",
  null
  
)

export default component.exports